import Vue from 'vue'
import axios from 'axios'
import Vueaxios from 'vue-axios'

Vue.use(Vueaxios, axios)
export default {

  stanDardCostNew (URL, header, body, success, error) {
    // request = {
    //   'item_id': 1,
    //   'item_code': '1001',
    //   'item_name': 'xxxx',
    //   'cost': 100,
    //   'unit_code': 'กระสอบ',
    //   'used_time': '2020-11-01 00:00:01'
    // }
    Vue.axios.post(URL + 'product/v1/standard/cost/new', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  stanDardCostUpdate (URL, header, body, success, error) {
    // request = {
    //   'id': 5,
    //   'item_id': 1,
    //   'item_code': '1001',
    //   'item_name': 'xxxx',
    //   'cost': 1000,
    //   'unit_code': 'กระสอบ',
    //   'used_time': '2020-11-10 00:00:01'
    // }
    Vue.axios.post(URL + 'product/v1/standard/cost/update', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  standartCostSearchID (URL, header, body, success, error) {
    // request = {
    //     "keyword":"5"
    // }
    Vue.axios.post(URL + 'product/v1/standard/cost/id', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getListStandard (URL, header, body, success, error) {
    // {
    // "item_code":""
    // }
    Vue.axios.post(URL + 'product/v1/standard/cost/search/keyword', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getListMe (URL, header, body, success, error) {
    // {
    // "item_code":""
    // }
    Vue.axios.post(URL, body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/services/stadard_cost.js